import React from 'react';

const Library: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="bg-white shadow rounded-lg p-6">
        <h1 className="text-2xl font-bold text-gray-900 mb-4">Library</h1>
        <p className="text-gray-600">
          Access articles, videos, and other resources for your wellness journey.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Articles</h3>
          <p className="text-gray-600">Educational articles about mental health and wellness.</p>
        </div>

        <div className="bg-white shadow rounded-lg p-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Video Exercises</h3>
          <p className="text-gray-600">Guided video exercises for relaxation and mindfulness.</p>
        </div>
      </div>
    </div>
  );
};

export default Library;
